(function() {
  // Hydrate flag emoji from ISO via Unicode regional indicators
  function _klxFlag(iso) {
    if (!iso || iso.length !== 2) return '';
    iso = iso.toUpperCase();
    var a = iso.charCodeAt(0), b = iso.charCodeAt(1);
    if (a < 65 || a > 90 || b < 65 || b > 90) return '';
    return String.fromCodePoint(127397 + a) + String.fromCodePoint(127397 + b);
  }
  function _klxHydrateFlags(root) {
    (root || document).querySelectorAll('.country-flag[data-klx-iso]').forEach(function (el) {
      if (el.textContent) return; // already filled
      el.textContent = _klxFlag(el.getAttribute('data-klx-iso'));
    });
  }
  _klxHydrateFlags();
  // Re-hydrate when the dropdown opens (DOM may have been built lazily)
  document.addEventListener('click', function () { setTimeout(_klxHydrateFlags, 50); });
})();
(function() {
  // Manual-choice marker only. Country switching itself is fully handled
  // by the stock component path (component.js dispatches
  // on:click="/selectCountry/XX" → localization.js sets country_code and
  // submits the form; Shopify then applies country/currency and, for
  // markets on their own domain, redirects there). An earlier layer here
  // used to schedule its own window.location redirect built from a
  // partial country→locale map — on any locale it didn't know (everything
  // except /en and /pl) that resolved to the SAME page and aborted the
  // in-flight form submit, which is why country clicks appeared dead.
  // The geo-redirect in theme.liquid only checks that the cookie EXISTS,
  // so it must be set on every manual language/country choice to stop
  // future visits from being auto-bounced.
  function karinexMarkManualChoice() {
    var d = new Date();
    d.setTime(d.getTime() + 30 * 86400000);
    document.cookie = 'karinex_lang_set=manual;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  window._karinexMarkManualChoice = karinexMarkManualChoice;
  document.addEventListener('click', function (event) {
    var item = event.target && event.target.closest && event.target.closest('[on\\:click^="/selectCountry/"]');
    if (!item) return;
    karinexMarkManualChoice();
    // No preventDefault, no navigation — the component's submit must win.
  }, true);
})();
(function () {
  // Karinex: wire up custom language list items inside the unified
  // dropdown card. Each <li data-lang-value="xx"> sets the hidden
  // <select> value and submits the form, matching how the country
  // list works via selectCountry on the component.
  function handleLangClick(li) {
    var form = li.closest('form');
    if (!form) return;
    var select = form.querySelector('select[name="language_code"]');
    if (!select) return;
    var iso = li.getAttribute('data-lang-value');
    if (!iso) return;
    if (window._karinexMarkManualChoice) window._karinexMarkManualChoice();
    select.value = iso;
    form.submit();
  }
  document.addEventListener('click', function (event) {
    var li = event.target && event.target.closest && event.target.closest('.language-selector__list-item[data-lang-value]');
    if (!li) return;
    event.preventDefault();
    event.stopPropagation();
    handleLangClick(li);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var li = event.target && event.target.closest && event.target.closest('.language-selector__list-item[data-lang-value]');
    if (!li) return;
    event.preventDefault();
    handleLangClick(li);
  });
})();
